// src/components/common/Button.jsx
import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  fullWidth = false,
  disabled = false,
  type = 'button',
  className = ''
}) => {
  const baseStyles = "font-medium py-2 px-4 rounded-md transition-all duration-300 focus:outline-none shadow-sm transform hover:translate-y-[-2px] btn-hover-effect";
  
  const variantStyles = {
    primary: "bg-indigo-600 text-white hover:bg-indigo-700 focus:ring-2 focus:ring-indigo-400 focus:ring-opacity-50",
    secondary: "bg-gray-700 text-gray-100 hover:bg-gray-600 focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50 border border-gray-600",
    danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-2 focus:ring-red-400 focus:ring-opacity-50",
    success: "bg-green-600 text-white hover:bg-green-700 focus:ring-2 focus:ring-green-400 focus:ring-opacity-50",
  };
  
  const widthStyles = fullWidth ? "w-full" : "";
  const disabledStyles = disabled ? "opacity-50 cursor-not-allowed hover:translate-y-0 transform-none" : "cursor-pointer";
  
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${widthStyles} ${disabledStyles} ${className}`}
    >
      {children}
    </button>
  );
};

export default Button;